export type TabProps<TabKey extends string> = {
  /** the title renderd on the tab */
  tabTitle: string;
  /** the subtitle renderd on the tab */
  tabSubTitle?: string;
  /** the icon to render on the tab */
  tabIconName?: string;
  /** prop to disable a tab default set to false */
  disabled?: boolean;
  /** the unique key value used to identify the tab, this is the value returned in onTabChange */
  key: TabKey;
  /** the component to render in the tabpanel when the tab is active */
  Component: React.ReactNode;
  /** the tabs & tab panel can be gotten by `role: 'tab'` and `role: 'tabpanel'` respectively with `name: tabTitle` */
  'data-testid'?: never;
};

export type TabbedComponentProps<TabKey extends string> = {
  /** the key value for the active tab */
  activeTab: TabKey;
  /** the list of tab configuration objects, the activeTab prop should equal the value of one of the tabs' key */
  tabs: TabProps<TabKey>[];
  /** the callback to be called when a new tab is selected, can be by keyboard, touch or click */
  onTabChange?: (tabKey: TabKey) => void;
  /** */
  'data-qa-id'?: string;
  /** */
  'data-testid'?: string;
};

export const validateTabsProp = <TabKey extends string>({
  tabs,
  componentName,
}: {
  tabs: TabProps<TabKey>[];
  componentName: string;
}) => {
  const arr = Array.isArray(tabs) ? tabs : [];
  const tabKeys = [];
  return arr.filter((tab, index) => {
    if (!tab.tabTitle) {
      console.warn(`${componentName}: tab with index ${index} is missing tabTitle value`);
      return false;
    }

    if (!tab.key) {
      console.warn(`${componentName}: tab with index ${index} is missing key value`);
      return false;
    }

    if (!tab.Component) {
      console.warn(`${componentName}: tab with index ${index} is missing a Component to render`);
      return false;
    }

    if (tabKeys.includes(tab.key)) {
      console.warn(`${componentName}: found multiple tabs with key ${tab.key}`);
      return false;
    }

    tabKeys.push(tab.key);
    return true;
  });
};
